import { Dispatch, SetStateAction } from "react";
import Overlay from "../../../../Component/Elements/Overlay/Overlay"
import useDeliveryAddressListREST from "../../hooks/REST/useDeliveryAddressListREST";
import { ProductDetail_SelectInformationDate_Address_Interface } from "../../static/interface/ProductDetail.interface";
import { addressListManagerClass } from "../../static/ts/common.tools";
import DeliveryAddressList from "./components/DeliveryAddressList/DeliveryAddressList";

const addressListManager = new addressListManagerClass();

const DeliveryAddressListOverlay = (
    {
        isOpen,
        overlayCloseHandler,
        address_index,
        addressList,
        setAddressList,
    }:{
        isOpen: boolean;
        overlayCloseHandler: () => void;
        address_index: number;
        addressList: ProductDetail_SelectInformationDate_Address_Interface[];
        setAddressList: Dispatch<SetStateAction<ProductDetail_SelectInformationDate_Address_Interface[]>>;
    }
) => {
    const {
        deliveryAddressListData,
    } = useDeliveryAddressListREST();

    const applyAddressHandler = (data: ProductDetail_SelectInformationDate_Address_Interface) => {
        addressListManager.editAddress({
            address_list: addressList,
            data,
            index: address_index,
            addressListSetter: setAddressList,
        })

        overlayCloseHandler();
    }

    return(
        <Overlay
            isOverlayOpen={isOpen}
            overlayCloseHandler={overlayCloseHandler}
        >
            <DeliveryAddressList
                addressList={deliveryAddressListData}
                applyAddressHandler={applyAddressHandler}
                product_qty={addressList[address_index].product_qty}
            />
        </Overlay>
    )
}

export default DeliveryAddressListOverlay;